import {useEffect, useState, useCallback} from "react";
import {useFirebaseState} from "./firebaseContext";
import {doc, onSnapshot, setDoc, serverTimestamp} from "firebase/firestore";

export const DEFAULT_BOOK_PRICE = 599;

export const useBookPricing = () => {
    const {db} = useFirebaseState();
    const [price, setPrice] = useState(DEFAULT_BOOK_PRICE);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!db) {
            setLoading(false);
            return;
        }

        const docRef = doc(db, "content", "books");
        const unsubscribe = onSnapshot(
            docRef,
            (snap) => {
                if (snap && snap.exists && snap.exists()) {
                    const data = snap.data();
                    if (data && typeof data.price === "number" && data.price > 0) {
                        setPrice(data.price);
                    }
                }
                setLoading(false);
            },
            (err) => {
                console.error("Feil ved henting av bokpris:", err);
                setError(err);
                setLoading(false);
            }
        );

        return () => unsubscribe();
    }, [db]);

    const updatePrice = useCallback(
        async (newPrice) => {
            const parsed = Number(newPrice);
            if (isNaN(parsed) || parsed <= 0) {
                throw new Error("Ugyldig pris. Prisen må være et positivt tall.");
            }
            if (!db) {
                throw new Error("Ingen databasetilkobling");
            }
            const docRef = doc(db, "content", "books");
            await setDoc(docRef, {price: parsed, updatedAt: serverTimestamp()}, {merge: true});
            setPrice(parsed);
        },
        [db]
    );

    return {price, updatePrice, loading, error};
};
